<template>
    <div class="features">
        <v-container class="text-center">
            <v-row>
                <v-col
                        v-for="({ icon, name, text }, i) in features"
                        :key="i"
                        cols="12"
                        md="4"
                >
                    <v-card
                            @click="$router.push({name: name})"
                            class="py-12 px-4"
                            color="grey lighten-5"
                    >
                        <v-theme-provider dark>
                            <div>
                                <v-avatar
                                        color="primary"
                                        size="88"
                                >
                                    <v-icon
                                            large
                                            v-text="icon"
                                    ></v-icon>
                                </v-avatar>
                            </div>
                        </v-theme-provider>

                        <v-card-title
                                class="justify-center font-weight-black text-uppercase"
                                v-text="name"
                        ></v-card-title>

                        <v-card-text
                                class="subtitle-1"
                                v-text="text"
                        >
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import {toolsListConstants} from '@/constants/toolsListConstants';

    export default {
        name: 'Features',
        data: () => ({
            features: toolsListConstants.filter((val) => val.name !== 'Tools')
        })
    }
</script>
<style type="text/css" scoped>
/*  CARD STYLES*/
.features .v-card:hover {
  cursor: pointer;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)
}


</style>
